import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {Phase} from "../types.ts";
import {usePhase} from "../hooks/usePhase.ts";
import {useParams} from "react-router-dom";
import {usePhases} from "../hooks/usePhases.ts";


export const AddFormDrawer = (props: DrawerProps) => {

    // The enclosing route is /playbooks/:id — :id is the playbookId.
    const {id: playbookId} = useParams();

    const {
        record,
        createRecord,
    } = usePhase();

    // Compute the next position as max(position) + 1 so a new phase is appended at the end.
    // If no phases exist yet the position starts at 0.
    const {items: existingPhases} = usePhases(playbookId ? {playbookId} : {});
    const nextPosition = existingPhases.length
        ? Math.max(...existingPhases.map(p => p.position ?? 0)) + 1
        : 0;

    const seededRecord = {
        ...(record ?? {}),
        ...(playbookId ? {playbookId} : {}),
        position: nextPosition,
    } as Phase;

    return (
        <FormDrawer
            record={seededRecord}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
